import { useContext, useEffect, useMemo, useState } from 'react'
import { rolesByOrg } from '@vt/apis/lib-ex/v2/role'
import {
  usersCustomInfo,
  addOrg as addOrgApi,
  editOrg as updateOrgApi,
  deleteOrg as deleteOrgApi,
} from '@vt/apis/lib-ex/v2/orgs'
import { getQuery } from '@vt/utils'
import OrgContext from './context'

const useOrg = function (appId) {
  const { tpl } = getQuery()

  const { orgs, roles, fetchOrgs } = useContext(OrgContext) || {}
  const [currentOrg, setCurrentOrg] = useState(null)
  const [currentOrgRoles, setCurrentOrgRoles] = useState([])

  // 当前分组
  const [currentGroup, setCurrentGroup] = useState('all')

  const [customInfo, setCustomInfo] = useState({})

  useEffect(() => {
    usersCustomInfo(appId, tpl).then((res) => {
      setCustomInfo(res.value || {})
    })
  }, [])
  const findOrg = (data) => {
    return data.reduce((a, item) => {
      if (a) return a
      if (item.slug === customInfo.orgSlug) return item
      if (item.children) return findOrg(item.children)
      return null
    }, null)
  }
  const _orgs = useMemo(() => {
    if (customInfo.orgSlug && orgs.length) {
      return [findOrg(orgs)]
    }
    return orgs
  }, [customInfo, orgs])

  const addOrg = (data, afterAdd) => {
    return addOrgApi(appId, data).then(() => {
      fetchOrgs()
      if (afterAdd) {
        afterAdd()
      }
    })
  }

  const updateOrg = (data, afterUpdate) => {
    return updateOrgApi(appId, data).then(() => {
      setCurrentOrg({ ...currentOrg, title: data.title })
      fetchOrgs()
      if (afterUpdate) {
        afterUpdate()
      }
    })
  }

  const deleteOrg = (afterDelete) => {
    return deleteOrgApi(appId, currentOrg.key).then(() => {
      fetchOrgs()
      setCurrentOrg(null)
      setCurrentGroup('all')
      if (afterDelete) {
        afterDelete()
      }
    })
  }

  // 分组
  const onSelectGroup = (group) => {
    const { code } = group
    setCurrentGroup(code)
    setCurrentOrg(null)
  }

  const onSelectOrg = (keys, info) => {
    console.log(keys)
    const { node = {} } = info
    setCurrentOrg(node)
    setCurrentGroup(null)
    // 获取该组织的角色
    rolesByOrg(appId, { parentOrgId: node.key }).then((data = []) => {
      setCurrentOrgRoles(
        data.map((item) => {
          return { value: item.slug, label: item.name, id: item.id }
        })
      )
    })
  }

  return {
    orgs: _orgs,
    roles: roles || [],
    customInfo,
    currentOrg,
    currentOrgRoles,
    currentGroup,
    fetchOrgs,
    orgOperate: {
      addOrg,
      updateOrg,
      deleteOrg,
    },
    userFilter: {
      onSelectOrg,
      onSelectGroup,
    },
  }
}

export default useOrg
